import React from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'

import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import { PermissionRedirect } from '../../account/components/sections'

import { UserEditorPage, UsersPage } from './pages'

const UsersRouter = () => (
  <>
    <Routes>
      <Route
        index
        element={
          <PermissionRedirect permissions={PERMISSIONS.USER.LIST}>
            <UsersPage />
          </PermissionRedirect>
        }
      />
      <Route
        path={APP_ROUTES.MISC.children.USERS.children.USER_CREATE.path}
        element={
          <PermissionRedirect permissions={PERMISSIONS.USER.CREATE}>
            <UserEditorPage />
          </PermissionRedirect>
        }
      />
      <Route
        path={APP_ROUTES.MISC.children.USERS.children.USER_DETAILS.path}
        element={
          <PermissionRedirect
            permissions={[PERMISSIONS.USER.UPDATE, PERMISSIONS.USER.GET]}
          >
            <UserEditorPage />
          </PermissionRedirect>
        }
      />
    </Routes>

    <Outlet />
  </>
)

export default UsersRouter
